import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from './api'; // ✅ Correct relative path
import './DeRegisterMerchant.css';

function DeRegisterMerchant({ user, onDeregisterComplete }) {
  const navigate = useNavigate();

  const [feedback, setFeedback] = useState({
    reason: '',
    suggestions: '',
    dynamicPricingHelpful: '',
    satisfiedVisibility: '',
    considerAgain: '',
    technicalIssues: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFeedback(prev => ({ ...prev, [name]: value }));
  };

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async () => {
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const res = await api.post('/users/deregister-merchant', {
        userId: user._id,
      });

      const updatedUser = {
        ...user,
        userType: 'pioneer',
        businessLogo: '',
        bannerImage: '',
      };
      localStorage.setItem('barterfi_user', JSON.stringify(updatedUser));

      if (typeof onDeregisterComplete === 'function') {
        onDeregisterComplete(updatedUser);
      }

      setSuccess('✅ You are no longer a Merchant.');
      setTimeout(() => {
        setSuccess('');
        navigate('/profile', { replace: true });
      }, 2000);
    } catch (err) {
      console.error(err);
      const msg = err?.response?.data?.message || 'Network error.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="deregister-container">
      {/* Top Bar */}
      <div className="deregister-topbar">
        <h2>De-Register as Merchant</h2>
      </div>

      {/* Scrollable Content */}
      <div className="deregister-scroll-content">
        {error && <div className="error-banner">{error}</div>}
        {success && <div className="success-banner">{success}</div>}

        <p>Why do you choose to de-register as merchant on BarterFi?</p>
        <textarea
          name="reason"
          value={feedback.reason}
          onChange={handleChange}
          placeholder="Optional..."
          rows={3}
        />

        <p>Do you have any suggestions for how we could improve the merchant experience?</p>
        <textarea
          name="suggestions"
          value={feedback.suggestions}
          onChange={handleChange}
          placeholder="Optional..."
          rows={3}
        />

        <p>Did you find the dynamic pricing system helpful?</p>
        <div className="radio-group">
          <label><input type="radio" name="dynamicPricingHelpful" value="Yes" onChange={handleChange} /> Yes</label>
          <label><input type="radio" name="dynamicPricingHelpful" value="No" onChange={handleChange} /> No</label>
        </div>

        <p>Were you satisfied with the visibility of your product or service?</p>
        <div className="radio-group">
          <label><input type="radio" name="satisfiedVisibility" value="Yes" onChange={handleChange} /> Yes</label>
          <label><input type="radio" name="satisfiedVisibility" value="No" onChange={handleChange} /> No</label>
        </div>

        <p>Would you consider becoming a merchant again in the future?</p>
        <div className="radio-group">
          <label><input type="radio" name="considerAgain" value="Yes" onChange={handleChange} /> Yes</label>
          <label><input type="radio" name="considerAgain" value="No" onChange={handleChange} /> No</label>
        </div>

        <p>Did you face any technical issues?</p>
        <textarea
          name="technicalIssues"
          value={feedback.technicalIssues}
          onChange={handleChange}
          placeholder="Optional..."
          rows={3}
        />
      </div>

      {/* Bottom Button Group */}
      <div className="deregister-button-group">
        <button className="deregister-cancel-btn" onClick={() => navigate('/profile', { replace: true })}>
          Cancel
        </button>
        <button className="deregister-submit-btn" onClick={handleSubmit} disabled={loading}>
          {loading ? 'Processing...' : 'De-Register'}
        </button>
      </div>
    </div>
  );
}

export default DeRegisterMerchant;
